Vue.component('ack-download-alpha-ai', {
	delimiters: ['${', '}$'],
	template: '#ack-download-alpha-ai',
	mixins: [languageMixins],
	created() {},
	mounted() {},
	props: {
		// dataIn: {
		//   type: Object,
		//   required: true
		// }
	},
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		//...Vuex.mapGetters('articles', ['articlesArray']),
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			pageId: 'download-alpha-ai-page',
			isFormSubmitted: false,
			alphaInfo: {
				first_icons_section: {
					items: [
						{
							img_plain_text:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_V4_icon_Mail.png?v=1727077083',
							plain_text_description:
								"1. Access your ALPHA AI download link from the confirmation email in your inbox. Can't find our email? Check your spam folder.",
						},
						{
							img_plain_text:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_Computer_Icon_111085ba-86dc-44af-98c5-d0bffa28e611.png?v=1726480898',
							plain_text_description: '2. Download and configue ALPHA AI on your system.',
						},
						{
							img_plain_text:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_ALPHA_AI_Icon_63749f2c-2145-49ef-8105-620ea790bbf7.png?v=1726480898',
							plain_text_description:
								'3. Start with our free subscription or elevate your workflow with <a href="https://ackuretta.com/checkouts/cn/Z2NwLWFzaWEtc291dGhlYXN0MTowMUo5Tk5XQjJLVkpDQlFLMUFKOEdGUU1TTg?preview_theme_id=126555684967" class="link">Premium.</a>',
						},
					],
				},
				second_icons_section: {
					items: [
						{
							video:
								'https://www.youtube.com/embed/Yn3kWUOgfzc?list=PLYrs3OiYaOuTO3gfDnHPEzlph-q-_6m6n&autoplay=0&rel=0&mute=1',
							video_title:
								'Watch ALPHA AI <a href="https://ackuretta.com/pages/video-gallery" target="_blank" class="link">video tutorials.</a>',
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_V4_icon_User.png?v=1727077149',
							title: ' Explore the ALPHA AI User Manual to familiarize yourself with its features.',
							link: 'https://cdn.ackuretta.com/downloads/alpha-ai/ALPHA%20AI%20-%20User%20Manual.pdf',
						},
					],
				},
				third_icons_section: {
					items: [
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_Warning_Icon_a976a61f-7c14-4a22-b38b-2c9dbea58cd2.png?v=1726480898',
							title: 'Submit a support ticket for quick assistance.',
							link: 'https://dashboard.ackuretta.com/',
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_Facebook_Logo_Icon_e35144e8-94f6-4635-b0b3-87aa91b5b6c9.png?v=1726480898',
							title: 'Join our community: share and learn with peers in our Facebook User Group.',
							link: 'https://www.facebook.com/Ackuretta/',
						},
						{
							img_src:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_V4_icon_Help.png?v=1727077148',
							title:
								'Open an account on the Ackuretta User Dashboard to self troubleshoot your issue or open a support ticket.',
							link: 'https://dashboard.ackuretta.com/',
						},
					],
				},
			},
		};
	},
	methods: {
		// ...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions('sliders', ['getSlideList'])

		handleFormSubmit() {
			this.isFormSubmitted = true;
		},
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
